import { useSensorResourceStore } from './useSensorResourceStore'

export default function useSensors({ projectId }: { projectId?: string }) {
  const { records, loading, schema, save } = useSensorResourceStore(projectId)

  return { records, loading, schema, save }
}
